module.exports = __webpack_public_path__ + "static/media/checkbox_check.0d9730ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/checkbox_check.svg
// module id = 195
// module chunks = 0